/// <amd-module name="SuiteCommerce.GiftCertificates.Collection"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificates.Collection", ["require", "exports", "underscore", "SuiteCommerce.GiftCertificate.Common.Utils", "Backbone", "SuiteCommerce.GiftCertificate.Model"], function (require, exports, _, Utils_1, Backbone_1, GiftCertificate_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.GiftCertificateCollection = void 0;
    var GiftCertificateCollection = /** @class */ (function (_super) {
        __extends(GiftCertificateCollection, _super);
        function GiftCertificateCollection() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.url = '/app/site/hosting/scriptlet.nl?script=customscript_ns_sc_sl_gift_cert_mgmt' +
                '&deploy=customdeploy_ns_sc_sl_gift_cert_mgmt';
            return _this;
        }
        Object.defineProperty(GiftCertificateCollection.prototype, "model", {
            get: function () {
                return GiftCertificate_Model_1.GiftCertificateModel;
            },
            enumerable: false,
            configurable: true
        });
        GiftCertificateCollection.prototype.parse = function (response) {
            response.forEach(GiftCertificate_Model_1.GiftCertificateModel.formatGCCurrency);
            return response;
        };
        GiftCertificateCollection.prototype.getBalance = function () {
            var _this = this;
            var giftCertificateBalance = [];
            var activeGiftCertificates = this.getActiveGiftCertificates();
            var balanceByCurrency = _.groupBy(activeGiftCertificates, function (giftCertificateModel) {
                return giftCertificateModel.currency.get('id');
            });
            _.each(balanceByCurrency, function (giftCertificateModels, currencyId) {
                // @ts-ignore
                var balanceAmount = _.reduce(giftCertificateModels, function (memo, giftCertificateModel) {
                    return memo + parseFloat(giftCertificateModel.amountRemaining);
                }, 0);
                var balanceAmountFormatted;
                var currency = giftCertificateModels[0].currency;
                if (currency && currency.symbol) {
                    var currencySymbol = currency.symbol;
                    balanceAmountFormatted = Utils_1.Utils.formatCurrency(balanceAmount.toFixed(2), currencySymbol);
                    balanceAmountFormatted = _this.fixSymbolPosition(balanceAmountFormatted, currency);
                }
                else {
                    balanceAmountFormatted = Utils_1.Utils.formatCurrency(balanceAmount.toFixed(2));
                }
                giftCertificateBalance.push({
                    balanceAmount: balanceAmount,
                    balanceAmountFormatted: balanceAmountFormatted,
                    currency: giftCertificateModels[0].currency,
                });
            });
            return giftCertificateBalance;
        };
        GiftCertificateCollection.prototype.fixSymbolPosition = function (amount, currency) {
            var symbol = currency.symbol;
            var symbolBefore = currency.symbolPlacement === 1;
            var amountWithoutSymbol = amount.replace(/^\D*|\D*$/g, "");
            if (symbolBefore) {
                return symbol + amountWithoutSymbol;
            }
            return amountWithoutSymbol + symbol;
        };
        GiftCertificateCollection.prototype.getActiveGiftCertificates = function () {
            return _.filter(this.models, function (giftCertificateModel) {
                return giftCertificateModel.isActive();
            });
        };
        return GiftCertificateCollection;
    }(Backbone_1.Collection));
    exports.GiftCertificateCollection = GiftCertificateCollection;
});
